<template>
  <div class="content">
    <p>收款人审核列表</p>
    <div class="actions-bar">
      <el-input placeholder="请输入账号ID" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>

      <el-select v-model="status" placeholder="请选择状态">
        <el-option label="全部" value=""></el-option>
        <el-option label="未同意" value="0"></el-option>
        <el-option label="审核中" value="1"></el-option>
        <el-option label="审核通过" value="2"></el-option>
        <el-option label="审核不通过" value="3"></el-option>
        <el-option label="被拒绝" value="4"></el-option>
      </el-select>
      <el-button type="primary" class="searchBtn" @click="handleSearch">搜索</el-button>
    </div>
    <el-table :data="OtcPayeeList" style="width: 100%">
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="merchantName" label="商家姓名"> </el-table-column>
      <el-table-column prop="merchantId" label="商家ID"> </el-table-column>
      <el-table-column prop="payeeName" label="收款人姓名"> </el-table-column>
      <el-table-column prop="payeeUserId" label="收款人ID"> </el-table-column>
      <el-table-column  label="关系">
         <template slot-scope="scope">
          <span v-if="scope.row.relation == 0">配偶</span>
          <span v-if="scope.row.relation == 1">父母</span>
          <span v-if="scope.row.relation == 2">子女</span>
          <span v-if="scope.row.relation == 3">亲戚</span>
          <span v-if="scope.row.relation == 4">朋友</span>
        </template>
      
       </el-table-column>
      <el-table-column prop="payeeInviteCode" label="收款人邀请码"> </el-table-column>

      <el-table-column prop="" label="状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未同意</span>
          <span v-if="scope.row.status == 1">审核中</span>
          <span v-if="scope.row.status == 2">审核通过</span>
          <span v-if="scope.row.status == 3">审核不通过</span>
          <span v-if="scope.row.status == 4">拒绝</span>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleDetail(scope.row.id)" type="text" size="small">查看</el-button>
          <el-button @click="handleClick(scope.row)" type="text" v-if="scope.row.status == 1" size="small">审核</el-button>
          <el-button @click="handleClick(scope.row)" type="text" v-else disabled size="small">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next, total, jumper"
      @current-change="pageChange"
      @size-change="sizeChange"
      :current-page="page"
      :page-size="size"
      :total="OtcPayeeListTotal"
      prev-text="上一页"
      next-text="下一页"
    >
    </el-pagination>
    <el-dialog title="审核" :visible.sync="auditlVisible" width="40%" center>
      审核ID:{{ auditForm.id }}
      <el-form :model="auditForm" status-icon ref="auditForm" label-width="100px" class="applicationForm">
        <p class="fromCaptionTitle">审核理由</p>
        <el-form-item label="理由" prop="nickName">
          <el-input type="textarea" v-model="auditForm.reason"></el-input>
        </el-form-item>
        <div class="fenGeXian"></div>

        <p class="fromCaptionTitle">基本信息</p>

        <el-form-item label="状态">
          <el-select v-model="auditForm.status" placeholder="请选择审核状态">
            <!-- <el-option label="未同意" value="0"></el-option> -->
            <!-- <el-option label="审核中" value="1"></el-option> -->
            <el-option label="审核通过" value="2"></el-option>
            <el-option label="审核不通过" value="3"></el-option>
            <!-- <el-option label="拒绝" value="4"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="auditlVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditPayeeBtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="merchantDetailVisible" width="40%" center>
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="applicationForm">
        <p class="fromCaptionTitle">商家信息</p>
        <el-form-item label="商户名">
          <el-input v-model.trim="ruleForm.merchantName" placeholder="中英字符或数字，16字符以内"></el-input>
        </el-form-item>
        <div class="fenGeXian"></div>

        <p class="fromCaptionTitle">基本信息</p>
        <el-form-item label="姓名" prop="name">
          <el-input v-model.trim="ruleForm.payeeName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="id" prop="tel">
          <el-input v-model.trim="ruleForm.id" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="merchantId" prop="wechat">
          <el-input v-model.trim="ruleForm.merchantId" placeholder="请输入微信"></el-input>
        </el-form-item>
        <el-form-item label="payeeUserId" prop="email">
          <el-input v-model.trim="ruleForm.payeeUserId" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="邀请码" prop="emergencyName">
          <el-input v-model.trim="ruleForm.payeeInviteCode" placeholder="请输入紧急联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="理由" prop="emergencyTel">
          <el-input v-model.trim="ruleForm.reason" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="与本人关系">
          <el-select v-model="ruleForm.relation" disabled placeholder="请选择与本人关系">
            <el-option label="配偶" value="0"></el-option>
            <el-option label="父母" value="1"></el-option>
            <el-option label="子女" value="2"></el-option>
            <el-option label="亲戚" value="3"></el-option>
            <el-option label="朋友" value="4"></el-option>
          </el-select>
        </el-form-item>
        <div class="setImgBox">
          <div class="imgBox">
            <span class="fromCaptionTitle">授权书</span>
            <img :src="ruleForm.accreditImage" alt="授权书" />
          </div>
          <div class="imgBox">
            <span class="fromCaptionTitle">关系证明</span>
            <img :src="ruleForm.relationImage" alt="关系证明" />
          </div>
        </div>
        <div class="fenGeXian"></div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="merchantDetailVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="merchantDetailVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import api from "../../api";
export default {
  name: "merchantRecordList",
  data() {
    return {
      status:'1',
      page: 1,
      size: 11,
      userId: "",
      // MerchantRecordList:{}
      merchantDetailVisible: false,
      auditlVisible: false,
      ruleForm: {},
      auditForm: {
        id: "",
        reason: "",
        status: ""
      }
    };
  },
  computed: {
    ...mapState("otc", ["OtcPayeeListTotal","OtcPayeeList"])
  },
  components: {},
  methods: {
    ...mapActions("otc", ["getOtcPayeeList"]),
    pageChange(e) {
      this.page = e;
      this.handleSearch();
    },
    sizeChange(e) {
      console.log("siziChange--", e);
       this.page = e;
      this.handleSearch();
    },

    handleDetail(id) {
      let that = this;
      this.merchantDetailVisible = true;
      api.getPayeeDetail(id).then(res => {
        console.log("收款人详情", res);
        if (!res.code) {
          that.ruleForm = res.data;
        }
      });
    },

    //shousuo
    handleSearch() {
      let that = this;
       if(that.userId) that.status=''
      this.getOtcPayeeList({
        userId: that.userId,
        status: that.status,
        size:that.size,
        page:that.page
      });
    },

    handleClick(row) {
      let that = this;
      this.auditlVisible = true;
      this.auditForm.id = row.id;
    },

    auditPayeeBtn() {
      let that = this;
      this.auditForm.id = this.auditForm.id.toString();
      this.auditForm.reason = this.auditForm.reason.toString();
      let data = this.auditForm;
      api.auditPayee(data).then(res => {
        console.log("收款人审核", res);
        if (!res.code) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          that.auditlVisible = false;
          that.handleSearch();
        } else {
          that.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  },

  mounted() {
    this.handleSearch();
  }
};
</script>

<style lang="less" scoped>
.content {
  .fenGeXian {
    width: 98%;
    height: 1px;
    background: #eaf0f2;
    clear: both;
    overflow: hidden;
    margin: 10px auto;
  }
  .actions-bar {
    width: 80%;
    display: flex;
    margin-bottom: 30px;
    .el-input {
      margin-right: 30px;
      width: 300px;
    }
    .searchBtn {
      margin-left: 15px;
    }
  }

  .setImgBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .imgBox {
      width: 46%;
      height: auto;
      border: 1px dashed #c8cdd1;
      padding: 12px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 80%;
        float: right;
      }
    }
  }
}
</style>
